'use client';

import { blackTransparentLoaderModalAtom } from '@/atom/modal';
import SpinnerLoader1818 from '@svg/common/spinner_loader_18_18.svg';
import { useAtom, useAtomValue } from 'jotai';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function BlackTransparentLoaderModal() {
  const pathname = usePathname();

  const [blackTransparentLoaderModal, setBlackTransparentLoaderModal] = useAtom(blackTransparentLoaderModalAtom);

  useEffect(() => {
    setBlackTransparentLoaderModal(false);
  }, [pathname]);

  useEffect(() => {
    if (!blackTransparentLoaderModal) {
      return;
    } else {
      const isNotHidden = document.body.style.overflowY !== 'hidden';
      if (isNotHidden) {
        document.body.style.overflowY = 'hidden';
      }

      return () => {
        if (isNotHidden) document.body.style.overflowY = 'auto';
      };
    }
  }, [blackTransparentLoaderModal]);

  if (!blackTransparentLoaderModal) {
    return null;
  }

  return (
    <div
      className={`fixed w-full max-w-480pxr top-0 z-[100] h-dvh overflow-hidden bg-custom-black/60 flex items-center justify-center animate-[fadeIn_300ms_ease-in-out]`}
    >
      <SpinnerLoader1818 className='animate-spin' />
    </div>
  );
}
